import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useAuth } from 'contexts/auth-context';
import qs from 'qs';
import Page from 'components/page/page';
import { attemptResetPassword } from 'utils/api';

import './auth-styles.scss';
function ResetPasswordPage() {

  console.log('in reset password page');
  const { user, setResetPassword, isInAppView } = useAuth();
  const [resetUUID, setResetUUID] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConf, setPasswordConf] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  // const { loginWithRedirect } = useAuth0();

  // const location = useLocation();
  // const isRedeemPage = location?.pathname.toLowerCase().includes('redeem');
  useEffect(() => {
    const searchVals = qs.parse(window.location.search.slice(1));
    console.log('in login', searchVals, 'my search Vals');

    if (searchVals.reset) {
      setResetUUID(searchVals.reset);
    } else {
      setTimeout(() => {
        if (!user) {
          window.location.href = 'https://hannafordhelpsschools.com';
        }
      }, 1500);
    }
  }, [user]);

  const submitResetPassword = async (e) => {
    e.preventDefault();
    console.log("in submitpassword function", e)
    if (password !== passwordConf) {
      setErrorMessage('Passwords do not match');
      return;
    }

    setIsLoading(true);
    setErrorMessage('');

    try {
      const resetRes = await attemptResetPassword(resetUUID, password);

      if (resetRes.Success) {
        setErrorMessage(resetRes.Message);
        const redirectUrl = isInAppView || window?.screen.width < 600
          ? 'https://hannafordhelpsschools.com'
          : 'https://portal.hannafordhelpsschools.com/login';
        history.push(redirectUrl);
      } else {
        setErrorMessage(resetRes.Message || 'Password reset failed.');
      }
    } catch (error) {
      setErrorMessage('An unexpected error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Page>
      <div className="login-container">
        <div className="col-sm-offset-4 login-box">
          <div className="login-header">
            <img src="header-logo1.png" alt="Hannafordimage" />
            <h3>Hannaford Helps Schools</h3>
          </div>

          <div className="reset-pw-form" id="loginButton">
            Reset Your Password
          </div>
          <hr />
          {errorMessage && (
            <div className={`alert ${resetUUID ? 'alert-success' : 'alert-danger'}`}>
              {errorMessage}
            </div>
          )}
          <form onSubmit={submitResetPassword} id="loginForm">
            <div className="form-group">
              <label htmlFor="name">Password</label>
              <div className="input-icon">
                <i className="fa fa-lock icon" />
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder="Enter your password"
                  minLength={6}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>{' '}
            <div className="form-group">
              <label htmlFor="name">Confirm New Password</label>
              <div className="input-icon">
                <i className="fa fa-lock icon" />
                <input
                  type="password"
                  className="form-control"
                  id="password-confirmation"
                  placeholder="Confirm your password"
                  minLength={6}
                  required
                  value={passwordConf}
                  onChange={(e) => setPasswordConf(e.target.value)}
                />
              </div>
            </div>{' '}
            <div className="captcha-container form-group" />
            <hr />
            <button
              type="submit"
              className="btn btn-danger btn-block"
              disabled={isLoading}
            >
              {isLoading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
          <br />
          <div className="captcha-container form-group">
            <Link to="/login">
              <button
                className="btn btn-link reset-pw"
                type="button"
                onClick={() => setResetPassword(true)}
              >
                <center>Send another Temporary Password.</center>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </Page>
  );
}
export default ResetPasswordPage;
